<template>

	<article id="calendar-container">

		<header>
			<h2>Vælg dato</h2>
			<button class="btn-close" @click="$router.go(-1)" title="Tilbage">×</button>
		</header>
		<p class="error" v-if="no_dates">
			Ingen ledige datoer denne måned
		</p>
	
		<div id="calendar">
			
			<calendar-view
				:show-date="showDate"
				:starting-day-of-week="1"
				class="theme-default"
				@click-date="selectDay"
				current-period-label="vis i dag"
				:disable-past="true"
				:date-classes="available_dates"
				:period-changed-callback="fetchAvailableDates">
				<calendar-view-header
					slot="header"
					slot-scope="t"
					:header-props="t.headerProps"
					@input="setShowDate" />
			</calendar-view>
		</div>

	</article>

</template>

<script>

	// Using vue-simple-calendar : https://github.com/richardtallent/vue-simple-calendar
	import { CalendarView, CalendarViewHeader } from 'vue-simple-calendar'
	import axios from '../../utils/Http.js'
	import { dateJs2django, dateDjango2js, leadZero } from '../../utils/Filters.js'

	export default {
		components: {
			CalendarView,
			CalendarViewHeader
		},
		data: function() {
			return { 
				showDate: new Date(),
				available_dates: {},
				no_dates: false
			}
		},
		computed: {
			startdatetime: function() {
				return this.$store.getters.getStartDateTime
			},
			resource: function() {
				return this.$store.getters.getResource
			},
			mindate: function() {
				if (this.$route.query.from) {
					// Maybe someone decides to limit which day is the minimum date to pick
					return parseInt(this.$route.query.from)
				} else {
					return new Date().getTime()
				}
			},
			maxdate: function() {
				// Set a maxdate 90 days out in the future
				let mdate = new Date().getTime() + 7603200000
				return mdate
			},
			user: function() {
				return this.$store.getters.getUser
			}
		},
		methods: {
			setShowDate: function(d) {
				this.showDate = d;
			},
			fetchAvailableDates: function(periods) {
				if (this.resource) {
					axios({
						url: `/booking/resource/${ this.resource.id }/availability/?start=${ encodeURIComponent(dateJs2django(periods.displayFirstDate)) }&end=${ encodeURIComponent(dateJs2django(periods.displayLastDate)) }`,
						method: 'get',
						headers: {
							'Authorization': 'Token ' + this.$store.state.auth.sessionKey
						}
					})
					.then(res => {
						let availlist = {}
						res.data.forEach(d => {
							// Only push to availlist when certain conditions are met
							if (dateDjango2js(d.end).getTime() > this.mindate) {
								const d_date = dateDjango2js(d.start)
								if (!this.user.is_staff && d_date.getTime() > this.maxdate) {
									return false
								} else {
									const d_key = `${ d_date.getFullYear() }-${ leadZero(d_date.getMonth() + 1 ) }-${ leadZero(d_date.getDate()) }`
									availlist[d_key] = 'free'
								}
							}
						})
						this.available_dates = availlist
						if (Object.keys(availlist).length < 1) {
							this.no_dates = true
						} else {
							this.no_dates = false
						}
					})
					.catch(err => console.log(err))
				}
			},
			selectDay: function(date) {
				const date_key = `${ date.getFullYear() }-${ leadZero(date.getMonth() + 1) }-${ leadZero(date.getDate()) }`
				if (this.available_dates[date_key] === 'free') {
					let dt = date
					if (this.startdatetime) {
						dt = new Date( new Date(this.startdatetime).setFullYear(date.getFullYear(), date.getMonth(), date.getDate()) )
					}
					this.$store.commit('setStartDateTime', dt)
					this.$emit('day-pick', dt)
				}
            }
		}
    }
    
</script>

<style lang="scss">

	@import './../../styles/vars.scss';
	
	#calendar-container {
		padding: 0 1rem;

		header {
			display: flex;
			justify-content: space-between;
			align-items: center;
		}
		h1 {
			margin: 0;
			font-size: 1.25rem;
			font-weight: normal;
			opacity: 1;
		}
	}

	#calendar {
		display: flex;
        flex-direction: column;
		flex-grow: 1;
		height: auto;

		min-height: 25rem;

		.cv-header {
			flex-flow: column nowrap;
		}
		.cv-header-nav {
			order: 2;
		}
		.periodLabel {
			order: 1;
		}
		.currentPeriod {
			font-size: .875rem;
			padding: .45rem .65rem;
		}
		.cv-day {
			min-width: 2.5rem;
			min-height: 2.5rem;
			opacity: .5;
			color: $grey3;
		}
        .today {
            border:solid .125rem $grey10;
		}
		.free.today,
		.free.future {
			background-color: $success;
			cursor: pointer;
			color: $grey10;
			opacity: 1;

			&:hover,
			&:active {
				background-color: darken($success, 10%);
			}
		}
		.free.outsideOfMonth {
			opacity: .5;
		}
	}

</style>